import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import enGB from '@frolight/assets/locales/globals/en-GB.json';

import config from '@frolight/config';

import { getLocales } from '@frolight/services/api/languageService';
import useLocalizationUtils from '@frolight/hooks/useLocalizationUtils';

const fetchSupportedLocales = async (abortController) => {
  if (abortController.signal.aborted) {
    return [];
  }
  try {
    const result = await getLocales(abortController);
    const locales = result?.data.length
    ? result.data.map(l => ({
        ...l,
        locale: `${l.language}-${l.region}`
      }))
    : [ config.i18n.defaultLocale ];
    return locales;
  } catch (err) {
    if (!abortController.signal.aborted) {
      console.error(err);
    }
    return [];
  }
};

let initialized = false;

export const initializeI18n = async (abortController) => {
  if (initialized || abortController.signal?.aborted) return;
  
  const { changeLocale } = useLocalizationUtils()

  const supportedLocaleObjects = await fetchSupportedLocales(abortController);
  if (abortController.signal.aborted) return;

  const supportedLocales = supportedLocaleObjects.map(l => l.locale);
  const browserLocale = navigator.language || navigator.userLanguage;
  const browserLanguage = browserLocale.split('-')[0];
  const fallbackLocaleForUser =
    supportedLocales.includes(browserLocale) 
      ? browserLocale 
      : supportedLocaleObjects.find(l => l.language === browserLanguage && l.localeIsDefaultForLanguage)?.locale || config.i18n.defaultLocale;

  await i18next
    .use(initReactI18next)
    .init({
      lng: fallbackLocaleForUser,
      fallbackLng: supportedLocales,
      supportedLngs: supportedLocales,
      interpolation: {
        escapeValue: false, // React already does escaping
      },
      resources: {
        'en-GB': {
          translation: enGB
        }
      },
      load: 'currentOnly'
    });
  if (abortController.signal.aborted) return;
  
  if (fallbackLocaleForUser !== config.i18n.defaultLocale) {
    changeLocale(fallbackLocaleForUser);
  }

  initialized = true;
};

export default i18next;
